import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 17 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:v=\"https://vecta.io/nano\" viewBox=\"0 0 17 13\" id=\"check\"><path d=\"M17 1L5 13 0 8l1-1 4 4L16 0l1 1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol